export default __webpack_public_path__ + "static/media/Torta-Da-Laranja.73e30d87.jpg";